


















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SAutocompleteOption<Option> extends Vue {
  @Prop({ type: Boolean, required: true }) private selected!: boolean;
  @Prop({ type: Boolean, required: true }) private focused!: boolean;
}
